import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router";

const routeScrollContainerSelector = '[data-route-scroll-container="true"]';

// SPA 스크롤 동작을 라우터 가까이에 둔다. 여기서 활성 viewport 를 초기화하지 않으면
// BrowserRouter 는 PUSH/REPLACE 이동에서 스크롤 위치를 유지한다.
export function RouteScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const didMountRef = useRef(false);

  useLayoutEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    if (navigationType === "POP" || location.hash) {
      return;
    }

    resetWindowScroll();
    resetRouteScrollContainers();
  }, [location.hash, location.pathname, location.search, navigationType]);

  return null;
}

function resetWindowScroll() {
  window.scrollTo({ left: 0, top: 0 });
}

function resetRouteScrollContainers() {
  document.querySelectorAll<HTMLElement>(routeScrollContainerSelector).forEach((element) => {
    element.scrollTo({ left: 0, top: 0 });
  });
}
